module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/transform.js
// module id = 138
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/transform.js